import React, { useState, useEffect, useRef } from "react";
import HttpClient from "../../utils/HttpClient";
import { useLanguage } from "../../Providers/LanguageContext";
import Select from 'react-select';
import './MilestonePopUp.css';
import toast from "react-hot-toast";
import { FaPlus, FaMinus } from 'react-icons/fa';

function MilestonePopUp({ closeModal }) {
    const { language } = useLanguage();
    const [formData, setFormData] = useState({
        projectId: "",
        phaseId: '',
    });
    const [milestones, setMilestones] = useState([{
        milestoneName: "",
        amount: 0,
        taskIds: [],
    }]);
    const [projects, setProjects] = useState([]);
    const [taskOptions, setTaskOptions] = useState([]);
    const [selectedTasks, setSelectedTasks] = useState([]);
    const [selectedProject, setSelectedProject] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [taskAllData, setTaskAllData] = useState([]);
    const [phases, setPhases] = useState([]);
    const [isUpdate, setIsUpdate] = useState(false);

    useEffect(() => {
        fetchProjects();
    }, []);

    useEffect(() => {
        if (taskAllData?.length) {
            const options = taskAllData.map(task => ({
                value: task._id,
                label: task.taskName
            }));
            setTaskOptions(options);
        } else {
            setTaskOptions([]);
        }
    }, [taskAllData]);

    const fetchProjects = async () => {
        const res = await HttpClient.requestData("view-all-project", "GET", {});
        if (res && res.status) {
            setProjects(res.data);
        } else {
            setProjects([]);
        }
    };

    const fetchTaskByProjectId = async projectId => {
        // const res = await HttpClient.requestData("gettaskprojectwise", "POST", {
        //     projectId,
        // });
        const res = await HttpClient.requestData("getnotdonetask", "POST", {
            projectId,
        });
        if (res && res.status) {
            setTaskAllData(res.data);
        } else {
            setTaskAllData([]);
        }
    };

    useEffect(() => {
        if (selectedProject) {
            fetchTaskByProjectId(selectedProject?._id);
        }
    }, [selectedProject]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "projectId") {
            setSelectedProject(projects?.find(project => project?._id === value) || null);
        }
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleMilestoneChange = (index, e) => {
        const { name, value } = e.target;
        const updatedMilestones = [...milestones];
        updatedMilestones[index] = {
            ...updatedMilestones[index],
            [name]: value
        };
        setMilestones(updatedMilestones);
    };

    const handleTaskSelectChange = (index, selectedOptions) => {
        const updatedMilestones = [...milestones];
        updatedMilestones[index].taskIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
        setMilestones(updatedMilestones);
    };

    const addMilestone = () => {
        setMilestones([...milestones, {
            milestoneName: "",
            amount: 0,
            taskIds: [],
        }]);
    };

    const removeMilestone = (index) => {
        if (milestones.length > 1) {
            const updatedMilestones = [...milestones];
            updatedMilestones.splice(index, 1);
            setMilestones(updatedMilestones);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const payload = {
                projectId: formData.projectId,
                phaseId: formData.phaseId,
                milestones: milestones.map(milestone => ({
                    ...milestone,
                    amount: +milestone.amount,
                    taskIds: [...milestone.taskIds]
                }))
            };

            // console.log("final submit payload: ", payload);


            const res = await HttpClient.requestData("createmilestone", "POST", payload);
            if (res && res.status) {
                toast.success(res?.message || "Milestones Added Successfully");
                setTimeout(() => {
                    closeModal();
                }, 1000);

                // Reset the form
                setFormData({
                    projectId: "",
                    phaseId: '',
                });
                setMilestones([{
                    milestoneName: "",
                    amount: 0,
                    taskIds: [],
                }]);
                setSelectedTasks([]);
            } else {
                toast.error(res?.error ? res?.error : res?.message);
            }
        } catch (error) {
            console.error("Error creating milestones:", error);
            toast.error(error?.error ? error?.error : error?.message);
        } finally {
            setIsLoading(false);
        }
    };

    const customStyles = {
        control: (provided) => ({
            ...provided,
            minHeight: '42px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            '&:hover': {
                borderColor: '#729FCF'
            }
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#e6f2ff'
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#003366'
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#003366',
            ':hover': {
                backgroundColor: '#cce0ff',
                color: '#002147'
            }
        })
    };

    const getExistingMilestonesByProjectId = async phaseId => {
        try {
            const res = await HttpClient.requestData('getmilestonebyprojectId', 'POST', {
                // projectId,
                phaseId,
            });
            if (res && res?.status) {
                console.log("milestone res of selected project id: ", res);

                setMilestones(res?.data?.map(item => {
                    const taskIds = item?.tasks?.length > 0 ? item?.tasks?.map(item2 => item2?.taskId) : [];
                    return {
                        _id: item?._id,
                        isCompleted: item?.isCompleted,
                        milestoneName: item?.milestoneName || "",
                        amount: item?.amount || 0,
                        taskIds,
                    }
                }));
            } else {
                toast.error(res?.message || 'something went wrong!!!');
                setMilestones([{
                    milestoneName: "",
                    amount: 0,
                    taskIds: [],
                }]);
            }
        } catch (error) {
            toast.error(error?.message || 'something went wrong!!!');
            setMilestones([{
                milestoneName: "",
                amount: 0,
                taskIds: [],
            }]);
        }
    };

    console.log('milestones: ', milestones);


    const getExistingPhasesByProjectId = async projectId => {
        try {
            const res = await HttpClient.requestData(`phases/${projectId}`, 'GET');
            if (res && res.data) {
                setPhases(res.data.map(phase => ({
                    _id: phase?._id,
                    name: phase.name,
                    amount: phase.amount,
                    milestones: phase.milestones || [],
                })));
            }
        } catch (error) {
            toast.error(error?.message || 'Failed to load existing phases');
            setPhases([{
                _id: "",
                name: "",
                amount: 0,
                milestones: [],
            }]);
        }
    };

    useEffect(() => {
        if (formData?.projectId?.length) {
            getExistingPhasesByProjectId(formData?.projectId);
        }
    }, [formData?.projectId]);

    useEffect(() => {
        if (formData?.phaseId?.length) {
            getExistingMilestonesByProjectId(formData?.phaseId);
        }
    }, [formData?.phaseId]);

    // console.log('formData in milestone: ', formData);
    // console.log("phases: ", phases);
    const modalRef=useRef();

    useEffect(()=>{
      const  OustideClickClose =(e)=>{
          if(modalRef.current && !modalRef.current.contains(e.target)){
            closeModal(false)
          }
      }
      document.addEventListener('mousedown',OustideClickClose)
    },[])


    return (
        <div className="modal-overlay">
            <div ref={modalRef} className="modal-content">
                <div className="modal-header">
                    <h3>{language.Milestone}</h3>
                    <button onClick={() => closeModal(false)} className="close-btn">×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>{language.Select_Project}</label>
                        <select
                            name="projectId"
                            value={formData.projectId}
                            onChange={handleChange}
                            required
                        >
                            <option value="">{language.select_project}</option>
                            {projects.map(project => (
                                <option key={project._id} value={project._id}>
                                    {project.projectName}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>{language.select_phase}</label>
                        <select
                            name="phaseId"
                            value={formData.phaseId}
                            onChange={handleChange}
                            required
                        >
                            <option value="">{language.select_phase}</option>
                            {phases?.length > 0 ? phases.map(phase => (
                                <option key={phase._id} value={phase._id}>
                                    {phase?.name}
                                </option>
                            )) : (<option value=''>No Phases Available ...</option>)}
                        </select>
                    </div>

                    {milestones.map((milestone, index) => (
                        <div key={index} className="milestone-group">
                            <div className="milestone-header">
                                <h4>Milestone {index + 1}</h4>
                                {milestones.length > 1 && (
                                    <button
                                        type="button"
                                        onClick={() => removeMilestone(index)}
                                        className="remove-milestone-btn"
                                    >
                                        <FaMinus />
                                    </button>
                                )}
                            </div>

                            <div className="form-group">
                                <label>{language.Milestone_Name}</label>
                                <input
                                    type="text"
                                    name="milestoneName"
                                    value={milestone.milestoneName}
                                    onChange={(e) => handleMilestoneChange(index, e)}
                                    placeholder={language.Milestone_Name}
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>{language.Amount}</label>
                                <input
                                    type="number"
                                    name="amount"
                                    value={milestone.amount}
                                    onChange={(e) => handleMilestoneChange(index, e)}
                                    placeholder={language.Amount}
                                    min="0"  // This prevents negative numbers
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label>{language.task_select}</label>
                                <Select
                                    isMulti
                                    name="tasks"
                                    options={taskOptions}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    onChange={(selected) => handleTaskSelectChange(index, selected)}
                                    placeholder={language.task_select}
                                    styles={customStyles}
                                    value={taskOptions.filter(option => milestone.taskIds.includes(option.value))}
                                />
                            </div>
                        </div>
                    ))}

                    <div className="add-milestone-btn-container">
                        <button
                            type="button"
                            onClick={addMilestone}
                            className="add-milestone-btn"
                        >
                            <FaPlus /> Add Another Milestone
                        </button>
                    </div>

                    <div className="modal-footer">
                        <button type="button" onClick={() => closeModal(false)} className="cancel-btn">
                            {language.cancel}
                        </button>
                        <button type="submit" className="submit-btn" disabled={isLoading}>
                            {isLoading ? language.creating : language.CREATE}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default MilestonePopUp;